export const SIGNUP_SUCCESS = (data) => ({
    type: 'SIGNUP_SUCCESS',
    payload: data
})
export const SIGNUP_FAIL = (data) => ({
    type: 'SIGNUP_FAIL',
    payload: data
})